import Base from "./base";

export default class Control extends Base {
    BASE_PATH = '/control'

    //全部应用信息
    apps() {
        return this.runGet("/apps")
    }

    //单个应用信息
    app(id) {
        return this.runGet(`/app/${id}`)
    }

    //全局广播
    globalBroadcast(msg) {
        return this.runPost("/app/broadcast-all", {
            message: msg
        })
    }

    //单个应用内广播
    appBroadcast(id, msg) {
        return this.runPost(`/app/broadcast/${id}`, {
            message: msg
        })
    }

    //应用分组广播
    groupBroadcast(id, group, msg) {
        return this.runPost(`/app/broadcast-group/${id}/${group}`, {
            message: msg
        })
    }

    //单个用户通知
    singleBroadcast(app, id, msg) {
        return this.runPost(`/app/broadcast/${app}/${id}`, {
            message: msg
        })
    }

    //全局下线
    globalOffline() {
        return this.runDelete("/offline-all")
    }

    //单个应用下线
    appOffline(id) {
        return this.runDelete(`/offline-app/${id}`)
    }

    //应用分组下线
    groupOffline(id, group) {
        return this.runDelete(`/offline-app/${id}/${group}`)
    }

    //单个用户下线
    singleOffline(app, id) {
        return this.runDelete(`/offline/${app}/${id}`)
    }

}